import type { FilterState } from '../filterTypes';

type BathroomState = FilterState['bathrooms'];

const ALL_BATH_VALUES = [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, '8plus'] as const;

/**
 * Expands bathroom minimum to the comma-delimited API format.
 * { min: 2 } → "2,2.5,3,3.5,4,4.5,5,5.5,6,6.5,7,7.5,8plus"
 * { min: null } → undefined (any baths, omit param)
 */
export function expandBathroomRange(bathrooms: BathroomState): string | undefined {
  if (bathrooms.min === null) return undefined;

  return ALL_BATH_VALUES.filter((v) => (typeof v === 'number' ? v >= bathrooms.min! : true))
    .map(String)
    .join(',');
}

/**
 * Parses baths from URL param.
 * "2" → { min: 2 }
 * "1.5" → { min: 1.5 }
 */
export function parseBathsFromUrl(value: string): BathroomState {
  const min = parseFloat(value);
  if (isNaN(min) || min < 0) return { min: null };
  return { min };
}
